import React from 'react';
import {useDispatch} from 'react-redux';
import querystring from 'query-string'
import classnames from 'classnames'
import {deselectItem, selectItem, updateItem, toggleMoreButton} from '../../../actions/contents/notice';
import {jsonResponseHandler} from '../../../utils/FetchHelper'
import EntryItemCheckbox from "../../common/EntryItemCheckbox";
import * as StatusTypes from "../../../constants/contents/EntryStatusTypes";
import NoticeListItemButton from "./NoticeListItemButton";
import {addPrefix} from "../../../utils/UriUtil";

function EntryTitle({item}) {
  return (
    <strong className="tit_post tit_ellip">
      <a href={(item.deleting) ? "#" : addPrefix(item.permalink)} title={item.title} className="link_cont" target="_blank">
        {item.isScheduled && <span className="info_status">[예약]</span>}
        {item.isRestrict && <span className="info_status">[{item.restrictLabel}]</span>}
        {item.title}
      </a>
      {item.hasFile && <span className="ico_blog ico_file"/>}
    </strong>
  )
}


export default function NoticeListItem({item}) {
  const dispatch = useDispatch()

  function handleSelect(e) {
    if (item.selected) {
      dispatch(deselectItem(item.id))
    } else {
      dispatch(selectItem(item.id))
    }
  }

  function handleVisible(item) {
    updateVisibility(item, {visibility: StatusTypes.PUBLIC});
  }

  function handleHidden(item) {
    updateVisibility(item, {visibility: StatusTypes.PRIVATE});
  }

  function updateVisibility(item, changes) {
    dispatch(updateItem(Object.assign(item, {processing: true})))
    fetch(addPrefix("/manage/notice/") + item.id + "/visibility.json", {
      method: "put",
      credentials: "include",
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: querystring.stringify(
        Object.assign({}, changes)
      )
    })
      .then(jsonResponseHandler(dispatch))
      .then(data => {
        dispatch(updateItem(Object.assign(item, changes, {processing: false})))
      })
      .catch(e => {
        dispatch(updateItem(Object.assign(item, {processing: false})))
        console.log(e)
      })
  }

  //  Mouse leave 이벤트에 열린 레이어를 닫기위해 toggle값을 -1 default값으로 셋팅한다.
  function mouseLeaveHandler(){
    dispatch(toggleMoreButton(-1))
  }

  return (
    <li className={classnames({item_dimmed: item.deleting})} onMouseLeave={mouseLeaveHandler}>
      <EntryItemCheckbox item={item} handleSelect={handleSelect}/>

      <div className="post_cont">
        <EntryTitle item={item} />
        <span className="txt_info fst">{item.author}</span>
        <span className="txt_info">{item.published}</span>
        {item.countOfComments && <span className="txt_info">댓글 {item.countOfComments}</span>}
      </div>

      <div className="post_btn">
        {item.visibility === StatusTypes.PRIVATE && <span className="ico_blog ico_private">비공개</span>}

        <div className="info_btn">
          <NoticeListItemButton
            item={item}
            handleHidden={handleHidden}
            handleVisible={handleVisible}
          />
        </div>
      </div>
    </li>
  )
}
